export default __webpack_public_path__ + "static/dokonala-skladacka-royal-canin-3cf02a940d8d73f525ae877aff4fb84b.png";